module.exports = __webpack_public_path__ + "static/img/2.0f28f9a5.jpg";